import type { StatefulDiaryT } from "@patient-watch/types";
import { redirect } from "@tanstack/react-router";
import { getConsentRedirectTarget } from "./consentGating";

export function redirectIfConsentRequired(
    diary: StatefulDiaryT | null | undefined,
    userId: string | undefined,
    isPatientViewer: boolean
): void {
    if (!diary || !isPatientViewer || !userId) {
        return;
    }

    const target = getConsentRedirectTarget(diary.consents_view, userId);
    if (target) {
        throw redirect(target);
    }
}
